/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LabeledValueDto } from './LabeledValueDto';
import {
    LabeledValueDtoFromJSON,
    LabeledValueDtoFromJSONTyped,
    LabeledValueDtoToJSON,
} from './LabeledValueDto';
import type { ResourceWorkloadStatusDto } from './ResourceWorkloadStatusDto';
import {
    ResourceWorkloadStatusDtoFromJSON,
    ResourceWorkloadStatusDtoFromJSONTyped,
    ResourceWorkloadStatusDtoToJSON,
} from './ResourceWorkloadStatusDto';

/**
 * 
 * @export
 * @interface ResourceStatusDto
 */
export interface ResourceStatusDto {
    /**
     * The resource I.
     * @type {string}
     * @memberof ResourceStatusDto
     */
    resourceId: string;
    /**
     * The type of the resource.
     * @type {string}
     * @memberof ResourceStatusDto
     */
    resourceType: string;
    /**
     * The name of the resource.
     * @type {string}
     * @memberof ResourceStatusDto
     */
    resourceName: string;
    /**
     * The workflows that have been create.
     * @type {Array<ResourceWorkloadStatusDto>}
     * @memberof ResourceStatusDto
     */
    workloads: Array<ResourceWorkloadStatusDto>;
    /**
     * Runtime properties collected live from the resource, for example the deployed image version.
     * @type {{ [key: string]: LabeledValueDto; }}
     * @memberof ResourceStatusDto
     */
    properties: { [key: string]: LabeledValueDto; };
}

/**
 * Check if a given object implements the ResourceStatusDto interface.
 */
export function instanceOfResourceStatusDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resourceId" in value;
    isInstance = isInstance && "resourceType" in value;
    isInstance = isInstance && "resourceName" in value;
    isInstance = isInstance && "workloads" in value;
    isInstance = isInstance && "properties" in value;

    return isInstance;
}

export function ResourceStatusDtoFromJSON(json: any): ResourceStatusDto {
    return ResourceStatusDtoFromJSONTyped(json, false);
}

export function ResourceStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resourceId': json['resourceId'],
        'resourceType': json['resourceType'],
        'resourceName': json['resourceName'],
        'workloads': ((json['workloads'] as Array<any>).map(ResourceWorkloadStatusDtoFromJSON)),
        'properties': (mapValues(json['properties'], LabeledValueDtoFromJSON)),
    };
}

export function ResourceStatusDtoToJSON(value?: ResourceStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resourceId': value.resourceId,
        'resourceType': value.resourceType,
        'resourceName': value.resourceName,
        'workloads': ((value.workloads as Array<any>).map(ResourceWorkloadStatusDtoToJSON)),
        'properties': (mapValues(value.properties, LabeledValueDtoToJSON)),
    };
}

